import { useAppSelector } from '../../../../../../hooks/reduxHooks';
import useProviderForm, { ProviderFormData } from '../../hooks/useProviderForm';
import { DrawerSvccCargando } from '../../../../components/drawer/DrawerSvcc';
import {
    DrawerSvccCuerpo,
    DrawerSvccEncabezado,
    DrawerSvccPie,
    DrawerSvccSeccion
} from '../../../../components/drawer/DrawerSvcc';
import CamposSvcc from '../../../../components/drawer/CamposSvcc';

/** Secciones del drawer, por `name` de la configuración de campos. */
const SECCIONES = [
    { clave: 'sustancia', nombres: ['substance', 'chemicalAndComercialName'] },
    { clave: 'proveedor', nombres: ['cuit', 'type'] }
];

const NewProviderDrawer = ({
    translate,
    selectedSubstance,
    handleCloseDrawer,
    isEditing,
    onlyVisual
}: any) => {
    const selectedCarcinogenicReportId = useAppSelector(
        (state) => state?.carcinogenicReport?.selectedCarcinogenicReportId
    );

    const {
        formData: providerFormData,
        errors: providerErrors,
        providerFieldsConfig,
        isCreatingProvider,
        isEditingProvider,
        handleChange: providerHandleChange,
        handleSubmit
    } = useProviderForm({
        selectedSubstance,
        selectedCarcinogenicReportId,
        isEditing,
        handleCloseDrawer
    });

    // En sólo lectura antes no había título; ahora dice que es una consulta.
    const claveTitulo = onlyVisual ? 'view' : isEditing ? 'edit' : 'new';

    return (
        <>
            <DrawerSvccEncabezado
                titulo={translate(`newProviderForm.titles.${claveTitulo}`)}
                paso={translate('newProviderForm.drawerPaso')}
                onCerrar={handleCloseDrawer}
            />
            <DrawerSvccCuerpo>
                {SECCIONES.map(({ clave, nombres }) => (
                    <DrawerSvccSeccion
                        key={clave}
                        titulo={translate(`newProviderForm.secciones.${clave}`)}
                    >
                        <CamposSvcc
                            config={providerFieldsConfig}
                            nombres={nombres}
                            formData={providerFormData as ProviderFormData & Record<string, any>}
                            errors={providerErrors}
                            onChange={providerHandleChange}
                            onlyVisual={onlyVisual}
                        />
                    </DrawerSvccSeccion>
                ))}
            </DrawerSvccCuerpo>
            <DrawerSvccPie
                onCancelar={handleCloseDrawer}
                onConfirmar={handleSubmit}
                textoCancelar={translate('newProviderForm.buttons.cancel')}
                textoConfirmar={translate('newProviderForm.buttons.save')}
                nota={onlyVisual ? undefined : translate('newProviderForm.todosObligatorios')}
                cargando={isCreatingProvider || isEditingProvider}
                sinConfirmar={onlyVisual}
            />
            <DrawerSvccCargando cargando={isCreatingProvider || isEditingProvider} />
        </>
    );
};

export default NewProviderDrawer;
